import React from 'react';
import PropTypes from 'prop-types';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { FDStack, FDTitleText } from '@facet-wealth/design';

export const ExpensesLayout = ({ label }) => {
  return (
    <FDStack direction="column" spacing={1}>
      <FDTitleText value={label} />
      <MetaLayoutRemainingFields noAccordion horizontal />
    </FDStack>
  );
};

ExpensesLayout.propTypes = {
  label: PropTypes.string.isRequired,
};
